import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { useMemo } from 'react'

import { useCockpitSettings } from 'partner360/features/financialCockpit/model/hooks/useCockpitSettings'

export interface ICockpitPartnerLinkParams {
  /** The fiscal year the cockpit is showing, so the partner page opens on the same one. */
  fYear: number
  /** The selected offering, or `undefined` for `ProgramTypes.Overall` — a pseudo-offering that means
   *  "all of them", so there is no real `ptype` to carry over. `PartnerNameWithLink` drops the
   *  segment entirely when this is `undefined`. */
  offering?: string
}

/** The cockpit context a `level: 'partner'` leaf's link carries into the partner's own page — the
 *  link counterpart of `usePartnerNameById`, resolved from the same cockpit settings both hierarchy
 *  tables already read.
 *
 *  Shared by the Revenue & SOB and Plan Quality tables so the Overall rule lives in one place
 *  rather than being restated at each call site. */
export const useCockpitPartnerLinkParams = (): ICockpitPartnerLinkParams => {
  const { selectedFYear, selectedOffering } = useCockpitSettings()

  return useMemo(
    () => ({
      fYear: selectedFYear,
      offering: selectedOffering === ProgramTypes.Overall ? undefined : selectedOffering,
    }),
    [selectedFYear, selectedOffering]
  )
}
